/**
 * Pro pricing / enquiry CTA + call + form tracking for GTM dataLayer.
 * Pushes events only when a non-blank tracking ID is present on the element
 * (except unmarked tel: links, which fire a lightweight cta_call catch-all).
 */
(() => {
  if (window.wundaCtaTrackingInitialised) {
    return;
  }

  window.wundaCtaTrackingInitialised = true;
  window.dataLayer = window.dataLayer || [];

  /**
   * @param {Record<string, string>} payload
   */
  window.wundaPushDataLayer = function wundaPushDataLayer(payload) {
    if (!payload || !payload.event) {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  };

  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) {
        return;
      }

      const tracked = event.target.closest('[data-cta-track]');

      if (tracked) {
        const ctaId = tracked.dataset.ctaId || '';

        if (!ctaId) {
          return;
        }

        const eventName = tracked.dataset.ctaEvent || 'cta_click';

        window.wundaPushDataLayer({
          event: eventName,
          cta_variant: tracked.dataset.ctaVariant || '',
          cta_id: ctaId,
        });
        return;
      }

      const telLink = event.target.closest('a[href^="tel:"], a[href^="TEL:"]');

      if (telLink) {
        window.wundaPushDataLayer({
          event: 'cta_call',
          cta_variant: 'tel_link',
          cta_id: '',
        });
      }
    },
    false
  );
})();
